var DialogApprovalsEquipmentsDiffModule = /** @class */ (function () {
    function DialogApprovalsEquipmentsDiffModule() {
    }
    return DialogApprovalsEquipmentsDiffModule;
}());
export { DialogApprovalsEquipmentsDiffModule };
